function sort_sizes() {
  if (jQuery(".option-size").length > 0) {
    const order = ["xxxs", "xxs", "xs", "s", "m", "l", "xl", "xxl", "xxxl"];
    const options = [];

    /**
     * Get DOM element and size char, to use it for ordering and DOM changes
     */
    $(".option-size > div").each(function (k, variant) {
      size_value = $(variant).children("label").attr("title").toLowerCase();
      options.push([size_value, variant]);
    });

    /**
     * Order options in array
     */
    for (i = 0; i < options.length; i++) {
      options.sort(function (cur, nxt) {
        let a = cur[0];
        let b = nxt[0];

        if (a === null || b === null) return;
        if (typeof a !== "string" || typeof b !== "string") return;

        let value1 = a.toLowerCase();
        let value2 = b.toLowerCase();
        let isSML = order.indexOf(value1) != -1;

        if (isSML) {
          return order.indexOf(value1) - order.indexOf(value2);
        } else {
          return a.match(/\d+/) - b.match(/\d+/);
        }
      });
    }

    /**
     * Order elements in the DOM
     */
    for (i = 0; i < options.length; i++) {
      if (i == 0) $(".option-size").prepend($(options[i][1]));
      else $($(options[i][1])).insertAfter($(options[i - 1][1]));
    }

    /**
     * Select first element in the list only if the 'variant' parameter
     * is not set in the URL
     */
    window.onload = (event) => {
      const urlParams = new URLSearchParams(window.location.search);

      if (!urlParams.has("variant"))
        $($(".option-size > div > input")[0]).click();
    };
  }
}

/*
 * When clicking on the Right/Left hand,
 * if no product is autoselected, select one
 */
document.addEventListener("DOMContentLoaded", () => {
  return; // FIX: The code is adding a right hand product when selecting a left hand product.
  // TODO: This is to debug and undestand what's the problem.

  const optionsContainers = document.querySelectorAll(
    '.product-form__option[data-selector-type="block"] .block-swatch-list',
  );

  const handOptionsContainer = optionsContainers[0];
  const clubsOptionsContainer = optionsContainers[1];
  const shaftOptionsContainer = optionsContainers[2];

  if (handOptionsContainer) {
    const handOptions = handOptionsContainer.querySelectorAll(
      'input[type="radio"]',
    );

    handOptions.forEach((handOption) => {
      handOption.addEventListener("change", function () {
        const selectedHand = this.value;

        const disabledClubOption = Array.from(
          clubsOptionsContainer.querySelectorAll(".block-swatch"),
        ).find((swatch) => swatch.classList.contains("block-swatch--disabled"));

        if (disabledClubOption) {
          const productData = JSON.parse(
            document.querySelector("[data-product-json]").textContent,
          );

          const availableVariant = productData.product.variants.find(
            (variant) => variant.option1 === selectedHand && variant.available,
          );

          if (availableVariant) {
            console.debug("Available Variant Found:", {
              hand: availableVariant.option1,
              clubs: availableVariant.option2,
              shaft: availableVariant.option3,
              variantId: availableVariant.id,
            });

            const variantSelect = document.querySelector(
              '.no-js select[name="id"]',
            );
            if (variantSelect) {
              const matchingOption = Array.from(variantSelect.options).find(
                (option) => option.value == availableVariant.id,
              );

              if (matchingOption) {
                variantSelect.value = availableVariant.id;
                variantSelect.dispatchEvent(
                  new Event("change", { bubbles: true }),
                );
              }
            }

            // Select Second option
            if (availableVariant.option2) {
              const clubsOptions = clubsOptionsContainer.querySelectorAll(
                'input[type="radio"]',
              );
              clubsOptions.forEach((option) => {
                if (
                  option.value === availableVariant.option2 &&
                  !option.disabled
                ) {
                  option.click();
                  console.debug(
                    "Clicked clubs option:",
                    availableVariant.option2,
                  );
                }
              });
            }

            // Select Third option
            if (availableVariant.option3 && shaftOptionsContainer) {
              const shaftOptions = shaftOptionsContainer.querySelectorAll(
                'input[type="radio"]',
              );
              shaftOptions.forEach((option) => {
                const label = option
                  .closest(".block-swatch")
                  ?.querySelector("label");
                const labelText = label?.textContent?.trim();
                if (
                  labelText === availableVariant.option3 &&
                  !option.disabled
                ) {
                  option.click();
                  console.debug(
                    "Clicked shaft option:",
                    availableVariant.option3,
                  );
                }
              });
            }
          } else {
            console.debug("No available variant found for", selectedHand);
          }
        }
      });
    });
  }
});
